import React from "react"

import Paragraphs from "@atoms/Paragraphs/Paragraphs"

import styles from "./Introduction.module.scss"

const Introduction = ({ text, align }) => {
  const camelCase = require("camelcase")
  return (
    <section className={`${styles.element} ${styles[camelCase("" + align)]}`}>
      <div className={styles.container}>
        <Paragraphs content={text} />
      </div>
    </section>
  )
}

export default Introduction
